import Api from '../../path';
import {fetchData} from '@umu/umu-fetch';


export interface IUseDepartmentBase {
    department_id: string;
    department_name: string;
}
export function getUseMyDepartment(se_id: string): Promise<IListResponse<IUseDepartmentBase>> {
    return fetchData(Api.USE_MY_DEPARTMENT, {se_id, page: 1, size: 20});
}
